import { allMathematicsWorksheetModuleTypes } from "@arbeidsark/shared"
import type { WorksheetMathematicsModuleType } from "@arbeidsark/shared"
import type React from "react"
import type { SelectOption } from "~/components"
import CheckSelectMultiple, {
  type CheckSelectMultipleProps,
} from "~/components/Select/CheckSelectMultiple"
import { useTranslate } from "~/ur-react-hooks"

export interface MathematicsTaskTypesMultiProps
  extends Omit<
    CheckSelectMultipleProps<WorksheetMathematicsModuleType>,
    "options"
  > {}

const MathematicsTaskTypesMultiSelect: React.FC<
  MathematicsTaskTypesMultiProps
> = ({ ...props }) => {
  const translations = useTranslate({
    "mathematics/neighbourNumbers":
      "worksheets.task-types.mathematics.neighbourNumbers",
    "mathematics/arithmetic": "worksheets.task-types.mathematics.arithmetic",
    "mathematics/sudoku": "worksheets.task-types.mathematics.sudoku",
    "mathematics/guessTheHouse":
      "worksheets.task-types.mathematics.guessTheHouse",
    "mathematics/numberPatterns":
      "worksheets.task-types.mathematics.numberPatterns",
    "mathematics/numberSeries":
      "worksheets.task-types.mathematics.numberSeries",
    "mathematics/grid": "worksheets.task-types.mathematics.grid",
    "mathematics/sorting": "worksheets.task-types.mathematics.sorting",
    "mathematics/pyramid": "worksheets.task-types.mathematics.pyramid",
    "mathematics/standardAlgorithm":
      "worksheets.task-types.mathematics.standardAlgorithm",
    "mathematics/mathCrossBox":
      "worksheets.task-types.mathematics.mathCrossBox",
    random: "worksheets.labels.random",
  })

  const options: SelectOption<WorksheetMathematicsModuleType>[] =
    allMathematicsWorksheetModuleTypes.map((type) => ({
      value: type,
      label: translations[type],
    }))

  return (
    <CheckSelectMultiple
      {...props}
      options={options}
      placeholder={translations.random}
    />
  )
}

export default MathematicsTaskTypesMultiSelect
